export const payoffDemandArr = [
    {
      title: "Loan Account Number",
      field: "LoanAccountNumber",
      type: "select",
      className: "col-12 py-4",
      options: [{ label: "", value: "" }],
    },
    // {
    //   title: "Loan Number",
    //   field: "LoanNumber",
    //   type: "text",
    //   className: "col-12",
    // },
  
    {
      title: "Payoff Good Through Date",
      field: "PayoffGoodThroughDate",
      type: "date",
      className: "col-6 py-4",
    },
    {
      title: "Demand Expiration Date",
      field: "DemandExpirationDate",
      type: "date",
      className: "col-6 py-4",
    },
    // {
    //   title: "Calculated Payoff",
    //   field: "CalculatedPayoff",
    //   type: "text",
    //   className: "col-12",
    // },
    {
      title: "Accrued Interest",
      field: "AccruedInterest",
      type: "text",
      className: "col-6 py-4",
    },
    {
      title: "Status",
      field: "Status",
      type: "select",
      options: [
        { label: "Approved", value: "Approved" },
        { label: "Cancelled", value: "Cancelled" },
        { label: "Delivered", value: "Delivered" },
        { label: "Expired", value: "Expired" },
        { label: "Pending", value: "Pending" },
        { label: "Submitted", value: "Submitted" },
      ],
      className: "col-6 py-4",
    },
  ];

  export const generatedFields = [
    {
      title: "Name",
      field: "Name",
    },
    {
      title: "Contact Person Name",
      field: "Contact Person Name",
    },
    {
      title: "Maturity Date",
      field: "Maturity Date",
    },
    {
      title: "Paidoffdate",
      field: "Paidoffdate",
    },
    {
      title: "Next Payment",
      field: "Next Payment",
    },
    {
      title: "Last Payment",
      field: "Last Payment",
    },
    {
      title: "Note Rate",
      field: "Note Rate",
    },
    {
      title: "Unpaid Interest",
      field: "Unpaid Interest",
    },
    {
      title: "Principal Balance",
      field: "Principal Balance",
    },
    {
      title: "Daily Rate using",
      field: "Daily Rate using",
    },
    {
      title: "Phonecell",
      field: "Phonecell",
    },
    {
      title: "Emailaddress",
      field: "Emailaddress",
    },
    {
      title: "Address",
      field: "Address",
    },
  ];